const PROTECTED_FONT_FAMILY_RE = /fontello|SFMono|Menlo|Monaco|Consolas|Courier New|Liberation Mono/i
const FONT_FACE_BLOCK_RE = /@font-face\s*\{[\s\S]*?\}/gi

const escapeHtmlAttribute = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')

export const transformCssFontFamilyToCmsVar = (css: string): string => {
  if (!css || !/font-family\s*:/i.test(css)) return css

  const protectedBlocks: string[] = []
  const protectedCss = css.replace(FONT_FACE_BLOCK_RE, (block) => {
    const token = `__CMS_FONT_FACE_BLOCK_${protectedBlocks.length}__`
    protectedBlocks.push(block)
    return token
  })

  const transformed = protectedCss.replace(/font-family\s*:\s*([^;{}]+);/gi, (match, value) => {
    const fontValue = String(value || '').trim()
    if (!fontValue || PROTECTED_FONT_FAMILY_RE.test(fontValue)) return match
    return `font-family: var(--cms-font-family, ${fontValue});`
  })

  return transformed.replace(/__CMS_FONT_FACE_BLOCK_(\d+)__/g, (_, index) => protectedBlocks[Number(index)] || '')
}

export const injectCmsFontFamilyStyleIntoFirstElement = (html: string, fontFamily: unknown): string => {
  const normalized = String(fontFamily || '').trim()
  if (!normalized || !html.trim()) return html

  const styleValue = `--cms-font-family: ${normalized}; font-family: ${normalized};`
  const escapedStyle = escapeHtmlAttribute(styleValue)

  return html.replace(/<([a-zA-Z][\w:-]*)([^>]*)>/, (_match, tagName, attrs) => {
    const attrText = String(attrs || '')

    if (/\sstyle\s*=\s*"/i.test(attrText)) {
      return `<${tagName}${attrText.replace(/\sstyle\s*=\s*"([^"]*)"/i, (_styleMatch, currentStyle) => {
        const mergedStyle = `${String(currentStyle || '').trim().replace(/;?\s*$/, ';')} ${styleValue}`.trim()
        return ` style="${escapeHtmlAttribute(mergedStyle)}"`
      })}>`
    }

    return `<${tagName}${attrText} style="${escapedStyle}">`
  })
}
